<template>
    <div id="login-form" class="container">
        <div class="row py-5">
            <h3 class="col-12">{{this.$store.state.role}} Login</h3>
        </div>
        <div class="row text-left align-items-center">
            <b-form @submit.prevent="login" class="col-12 col-md-6 col-lg-4 mx-auto">
                <b-form-group label="Email" label-for="email">
                    <b-form-input id="email" v-model="loginEmail"
                                  type="email" placeholder="email@example.com"/>
                </b-form-group>
                <b-form-group label="Password" label-for="password">
                    <b-form-input id="password" v-model="loginPassword"
                                  type="password" placeholder="*******"/>
                </b-form-group>
                <div class="text-center py-3">
                    <b-button class="m-1" pill @click="reset" variant="dark">Back</b-button>
                    <b-button class="m-1" pill @click="login">Login</b-button>
                </div>
            </b-form>
        </div>
        <transition name="fade">
            <div v-if="errorMsg !== ''" class="error-msg">
                <p>{{ errorMsg }}</p>
            </div>
        </transition>
        <div class="py-5">
            <a @click="goSignUp">Create an account</a><br>
        </div>
    </div>
</template>

<script>
import firebase from '../../firebase';

export default {
    name: 'LoginForm',
    data() {
        return {
            loginEmail: '',
            loginPassword: '',
            errorMsg: ''
        };
    },
    methods: {
        login() {
            this.$emit('requesting', true);
            firebase.auth.signInWithEmailAndPassword(this.loginEmail, this.loginPassword)
                .then((response) => {
                    this.$store.commit('setCurrentUser', response.user);
                    this.$store.dispatch('fetchUserProfile');
                    firebase.usersCollection.doc(response.user.uid)
                        .get()
                        .then((res) => {
                            if (res.data().role !== this.$store.state.role) {
                                this.errorMsg = `You are registered as a ${res.data().role}`;
                                this.logout();
                                this.$emit('requesting', false);
                            } else {
                                this.$router.push({ name: 'Home' });
                                this.$emit('requesting', false);
                            }
                        });
                })
                .catch((err) => {
                    this.errorMsg = err.message;
                    console.log(err);
                    this.$emit('requesting', false);
                });
        },
        logout() {
            firebase.auth.signOut().then(() => {
                this.$store.dispatch('clearData');
            }).catch((err) => {
                console.log(err);
            });
        },
        reset() {
            this.$emit('resetRole');
        },
        goSignUp() {
            this.$emit('goSignUp');
        }
    }
};
</script>
